import { reqGet, reqPost, reqPut } from './axiosFun'

/**
 * 获取指定年份的月报数据
 */
export function getByYear(year) {
  return reqGet(`/fin-monthly-report/year/${year}`)
}

/**
 * 更新手动字段
 */
export function updateManualFields(data) {
  return reqPut('/fin-monthly-report', data)
}

/**
 * 计算指定月份数据
 */
export function calculateMonthlyData(year, month) {
  return reqPost(`/fin-monthly-report/calculate/${year}/${month}`)
}

/**
 * 刷新缓存
 */
export function refreshCache(year) {
  return reqPost(`/fin-monthly-report/refresh-cache/${year}`)
}



// WEBPACK FOOTER //
// ./src/api/FinancialMonthlyReport.js